<template>
  <div class="bg-surface-container-low mt-2 overflow-hidden rounded-full">
    <TabList v-slot="{ selectedIndex }">
      <BaseHorizontalOverflow show-buttons>
        <BaseButtonGroup class="flex w-fit max-w-none! flex-row lg:w-full">
          <Tab
            v-for="(tab, index) in lessonImpulseTabItems"
            :key="tab.id"
            :value="tab.id"
            as="template"
          >
            <BaseTextButton
              color="tonalPrimary"
              toggle
              size="M"
              :selected="selectedIndex === index"
              class="grow rounded-full! border-none! outline-none hover:shadow-none! lg:basis-0"
              :class="[
                selectedIndex === index && 'bg-primary-container text-on-primary-container',
                selectedIndex != index && 'text-on-surface-variant bg-transparent!',
              ]"
            >
              {{ tab.title }}
            </BaseTextButton>
          </Tab>
        </BaseButtonGroup>
      </BaseHorizontalOverflow>
    </TabList>
  </div>
</template>

<script lang="ts" setup>
  import { Tab, TabList } from '@headlessui/vue'
  import BaseButtonGroup from '@/core/components/base/button/BaseButtonGroup.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useLessonImpulseTabItems } from '../models/lesson-impulse-tabs'

  const lessonImpulseTabItems = useLessonImpulseTabItems()
  import BaseHorizontalOverflow from '@/core/components/base/horizontal-overflow/BaseHorizontalOverflow.vue'
</script>
